import { useEffect, useRef } from 'react';
import { useCases } from '../../../mocks/landingData';

export default function UseCasesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 bg-midnight">
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-royal-navy/10 to-midnight" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full bg-champagne-gold/3 blur-3xl" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="animate-on-scroll opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-champagne-gold/30 bg-champagne-gold/10 mb-6">
              <i className="ri-briefcase-line text-champagne-gold text-sm" />
              <span className="text-champagne-gold text-sm font-medium">Use Cases</span>
            </div>

            <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-white mb-6">
              Use TNT Coach AI when you are{' '}
              <span className="gold-gradient-text">...</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-3 gap-4 md:gap-5">
            {useCases.map((useCase, index) => (
              <div
                key={index}
                className="animate-on-scroll opacity-0 group flex items-center gap-4 p-5 rounded-xl bg-royal-navy/20 border border-royal-navy/30 hover:border-champagne-gold/30 hover:bg-royal-navy/30 transition-all duration-300 card-hover"
              >
                <div className="w-10 h-10 rounded-lg gold-gradient flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${useCase.icon} text-midnight text-lg`} />
                </div>
                <p className="text-warm-white text-sm font-medium">{useCase.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}